const REFERRAL_CODE_COOKIE = 'fg-referral'
const REFERRAL_SOURCE_COOKIE = 'fg-referral-source'
const COOKIE_MAX_AGE_SECONDS = 30 * 24 * 60 * 60 // 30 days

export function setReferralCookies(referralCode: string, source: string): void {
  document.cookie = `${REFERRAL_CODE_COOKIE}=${encodeURIComponent(referralCode)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`
  document.cookie = `${REFERRAL_SOURCE_COOKIE}=${encodeURIComponent(source)}; path=/; max-age=${COOKIE_MAX_AGE_SECONDS}; SameSite=Lax`
}

export function getReferralCookies(): { referralCode: string | null; referralSource: string | null } {
  const cookies = document.cookie.split(';').reduce<Record<string, string>>((acc, cookie) => {
    const [key, value] = cookie.trim().split('=')
    if (key && value !== undefined) acc[key] = decodeURIComponent(value)
    return acc
  }, {})
  return {
    referralCode: cookies[REFERRAL_CODE_COOKIE] ?? null,
    referralSource: cookies[REFERRAL_SOURCE_COOKIE] ?? null,
  }
}

export function clearReferralCookies(): void {
  document.cookie = `${REFERRAL_CODE_COOKIE}=; path=/; max-age=0`
  document.cookie = `${REFERRAL_SOURCE_COOKIE}=; path=/; max-age=0`
}
